import { FC, useState } from 'react';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { VIDEO_CONFIG } from '@/entities/interwills/hooks/useWebcamRecorder/config';
import { media } from '@/shared/components';
import VideoPlayer from '@/shared/components/VideoPlayer';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

type PreviewTabProps = {
  videoUrl: string;
  onSave: () => Promise<void>;
  onBack: () => void;
};

export const PreviewTab: FC<PreviewTabProps> = ({ videoUrl, onBack, onSave }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'recordingModal' });

  const [loading, setLoading] = useState(false);

  const onSaveHandler = async () => {
    setLoading(true);
    await onSave();
    setLoading(false);
  };

  return (
    <Container>
      <VideoWrapper>
        <VideoPlayerStyled
          options={{
            controls: true,
            muted: false,
            preload: 'auto',
            sources: [
              {
                src: videoUrl,
                type: VIDEO_CONFIG.videoContainer,
              },
            ],
            fill: true,
            enableSmoothSeeking: true,
          }}
        />
      </VideoWrapper>
      <Buttons>
        <ButtonIwStyled onClick={onBack} type="text" icon={<Icon name="arrow-left" size="s20" />}>
          {t('backBtn')}
        </ButtonIwStyled>
        <ButtonIw onClick={onSaveHandler} type="default" loading={loading} disabled={loading}>
          {t('saveBtn')}
        </ButtonIw>
      </Buttons>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: space-between;
`;

const VideoWrapper = styled.div`
  border-radius: 16px;
  overflow: auto;
  height: 100%;

  > * {
    height: 100%;
  }
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.iwMobile} {
    flex-direction: column-reverse;
    gap: 16px;
  }
`;

const ButtonIwStyled = styled(ButtonIw)`
  color: ${COLORS.white}!important;
`;

const VideoPlayerStyled = styled(VideoPlayer)`
  ${media.iwMobileOrLandscape} {
    position: absolute;
    inset: 0;

    .vjs-control-bar {
      margin-bottom: 160px;
    }

    .vjs-tech {
      object-fit: cover;
    }
  }
`;
